import { queryOptions } from '@tanstack/react-query'

export const getPrivacyPolicyQuery = queryOptions({
  queryKey: ['privacy-policy'],
  queryFn: () => getPolicy('privacy-policy-lawfully-pro'),
})

export const getTermsOfServiceQuery = queryOptions({
  queryKey: ['terms-of-service'],
  queryFn: () => getPolicy('terms-of-service-lawfully-pro'),
})

const getPolicy = async (slug: string) => {
  const query = `
*[_type == "policy" && slug.current == "${slug}"] {
  lastUpdateDate,
  content,
}
`
  const encoded = encodeURIComponent(query)
  const res = await fetch(`https://57rvft8a.apicdn.sanity.io/v2021-06-07/data/query/production?query=${encoded}`)
  const data = (await res.json()) as {
    result: {
      lastUpdateDate: string
      content: string
    }[]
  }
  return data.result[0]
}
